import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import {
    ButtonController,
    IButtonControllerOptions,
} from '../../../../Common/ButtonController';
import { AnimationContents } from '../../../../../AnimationContents';
import { AppStateEnum, GameModel } from '../../../../Models/Game/GameModel';
import { GameLogic } from '../../../../Logic/GameLogic';

export class SaveScreenController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super('SaveScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.SAVE_SCREEN_JSON,
            libraryName: 'main',
            childControllers: {
                closeButton: {
                    instanceName: 'window.container.btn_close',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlay('window close');
                            this.$queue.get('hide').addToQueue();
                        },
                    },
                },
                okButton: {
                    instanceName: 'window.container.btn_ok',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlay('window close');
                            this.$queue.get('hide').addToQueue();
                        },
                    },
                },
            },
            queue: {
                hide: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        this._gameLogic.showMenuScreen();
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndPlay('window initialization')
    }

    protected onLandscape(): void {
        this.display.scale.set(1.3);
        this.display.y = 25;
    }
}
